require('./es6.array.iterator');
var Iterators = require('./$.iterators');
Iterators.NodeList = Iterators.HTMLCollection = Iterators.Array;


//////////////////
// WEBPACK FOOTER
// C:/wamp/www/node_modules/core-js/library/modules/web.dom.iterable.js
// module id = 231
// module chunks = 0